import*as e from"react";const t="undefined"!=typeof window?e.useLayoutEffect:e.useEffect;function r(r){const u=e.useRef(r);return t((()=>{u.current=r})),e.useRef(((...e)=>(0,u.current)(...e))).current}export{t as a,r as u};
//# sourceMappingURL=useEventCallback-6e6f3981.js.map
